import { EventAction } from './event.action'

export class EventActionGroup {
    start?: EventAction
    end?: EventAction
    intervals: EventAction[] = [] // uncertain how we will show intervals atm

    constructor(readonly id: string) {}
}
